<template>
  <div>
    <Navbar v-if="this.$route.name == 'partners'"/>
    <Breadcrumb v-if="this.$route.name == 'partners'" />      
    <div v-show="partner_id == 0">
      <b-row class="col-12">

      <b-input-group small class="col-3 mt-3 mb-3">
        <b-button @click.prevent.stop="addpartner" variant="primary" class="gdq_faded"><span class="icon-plus mr-2"></span>Add partner</b-button>
        <!-- span class="mt-2 ml-4 mr-2">Bulk actions: </span -->
        <b-form-select 
          placeholder="Bulk action" 
          v-model="bulkaction" 
          @input="bulkaddlabel" 
          class="ml-4 rounded"
        >
          <option value=0 class="text-muted">Bulk action</option>
          <option value=1>Add label</option>
          <option value=2>Do something else</option>
        </b-form-select>
      </b-input-group>

      <b-input-group small class="col-6 mt-3 mb-3">
        <span class="pt-2">Filter:</span>
        <LabelSelect 
          @input="partners_filterget" 
          v-model="filterlabel" 
          :options="alllabels" 
          class="col-7 rounded" 
          placeholder="All labels"
        />
      </b-input-group>

      <b-input-group small class="col-3 mt-3 mb-3">
        <b-form-input
          v-model="search"
          placeholder="Search name or e-mail"
          type="text"
          @input="partners_filter"
          autocomplete="off"
        >
        </b-form-input>
        <b-input-group-text slot="append">
          <b-btn
            variant="link"
            size="sm"
            @click="search = ''"
            class="p-0 i"
          >
          X
          </b-btn>
        </b-input-group-text>
      </b-input-group>
      </b-row>
      <b-table 
        id="partners"
        hover 
        :items="partners" 
        :fields="fields"
        :busy="loading"
        :sort-by="orderby"
        :sort-desc="orderdesc"
        @sort-changed="partners_sort"
        :no-local-sorting="true"
        ref="partners"
        @row-clicked="editpartner"
      >
        <template v-slot:head(select)="data">
          <b-form-checkbox
          @click.native.stop
            @change="selectall(selected)"
            v-model="selected"
          >
            <span class="text-muted" v-if="selectcount>0">({{selectcount}})</span>
          </b-form-checkbox>
        </template>
      <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner variant="primary" class="align-middle"></b-spinner>
          </div>
        </template>
        <template v-slot:cell(select)="data">
        <div class="py-1">
            <b-form-checkbox
              :id="'selected'+data.index"
              v-model="data.item.selected"
              @change="countselected"
            >
            </b-form-checkbox>
          </div>
        </template>
        <template v-slot:cell(partner_name)="data">
          <div class="py-1">
            {{ data.item.partner_name }}
          </div>
        </template>
        <template v-slot:cell(labels)="data">
          <div class="form-inline py-0">
            <span v-bind:key="label.id" v-for="label in data.item.labels" :style="{'background': '#'+label.color}" class="mr-2 py-1 pl-2 pr-2 rounded">
              {{ label.label }}
              <span 
                @click.stop.prevent="removelabel(data.item.id,label.id)"
                class="ml-2"
              >
                <fa-icon name="trash-alt" />
              </span>
            </span>
            <span 
              v-show="addinglabel==0"
              class="icon-plus pt-0 text-secondary"
              :class="data.item.labels.length==0?'pt-2':'pt-0'"
              @click.stop.prevent="addlabel(data.item.id)"
            >
            </span>
  
            <b-input-group 
            v-show="addinglabel==data.item.id"
              small class="col-3 pl-0 ml-0 py-0 my-0">
              <b-form-input
                small
                datalist="labellist"
                class="form-control-sm py-0"
                v-model="addinglabeltext"
                placeholder="Add label"
                type="text"
                @keyup.enter.prevent="saveaddlabel"
                @keyup.escape.prevent="addinglabel = 0"
                :ref="'l'+data.item.id"
                autocomplete="off"
              >
              </b-form-input>
              <b-input-group-text class="py-0" slot="append">
                <b-btn
                  variant="link"
                  size="sm"
                  @click="addinglabel = 0"
                  class="p-0 i"
                >
                X
                </b-btn>
              </b-input-group-text>
              <datalist id="labellist">
                <option :key="label.id" v-for="label in alllabels">{{ label.label }}</option>
              </datalist>
            </b-input-group>
          </div>
        </template>
      </b-table>
      <b-row class="col-12 justify-content-center">
        <b-pagination
          v-if="rows > perPage"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="partners"
          @input="partners_get"
        >
        </b-pagination>
      </b-row>
    </div>
    <div v-show="partner_id != 0">
      <Partner />
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import LabelSelect from './LabelSelect';
import Partner from './Partner';
import Navbar from './Navbar.vue';
import Breadcrumb from './Breadcrumb.vue'

const fields = [
  { key: 'select', label: '', sortable: false },
  { key: 'partner_name', label: 'Name', sortable: true },
  { key: 'labels', label: 'Labels', sortable: false, tdClass: 'col-5' },
  { key: 'empty', label: '', sortable: false, tdClass: 'col-1' },
];
export default {
  components: {
    Partner,
    LabelSelect,
    Navbar,
    Breadcrumb,
  },
  name: 'Partners',
  mounted() {
    this.partners_get()
    this.labels_get();
  },
  data: function() {
    return {
      search: '',
      searching: false,
      searchcalc: false,
      fields: fields,
      partners: [],
      allowmultiselect: false,
      muteclass: 'text-muted',
      currentPage: 1,
      perPage: 10,
      rows: 0,
      loading: null,
      orderby: 'partner_name',
      orderdesc: false,
      selected: 0,
      addinglabel: 0,
      addinglabeltext: '',
      filterlabel: 0,
      alllabels: [],
      filterusergroup: 0,
      bulkaction: 0,
      selectcount: 0,
    }
  },
  computed: {
    partner_id: {
      get() {
        return this.$store.state.currentpartner_id;
      }
    },
    partnerchanged: {
      get() {
        return this.$store.state.partnerchanged;
      }
    },
    partnerlabelchanged: {
      get() {
        return this.$store.state.partnerlabelchanged;
      }
    }
  },
  watch: {
    search: function() {
      this.searching = true
      this.partners_filter()
    },
    partnerchanged: function() {
      if (this.$store.state.partnerchanged != 0) {
        this.partner_get(this.$store.state.partnerchanged);
        this.$store.dispatch('partnerchanged_set',{ partner_id: 0 });
      }
    },
    partnerlabelchanged: function() {
      if (this.$store.state.partnerlabelchanged != 0) {
        this.conlabels_get(this.$store.state.partnerlabelchanged);
        this.$store.dispatch('partnerlabelchanged_set',{ partner_id: 0 });
      }
    },
    partner_id: function() {
      this.partners_get();
    },
  },
  methods: {
    bulkaddlabel() {

    },
    addpartner() {
      this.$store.dispatch('partner_setcurrent',{ partner_id: -1 })
    },
    editpartner(item) {
      this.$store.dispatch('partner_setcurrent',{ partner_id: item.id })
    },
    saveaddlabel() {
      if (this.addinglabeltext != '') {
        var savelabel = {
          partner_id: this.addinglabel,
          label: this.addinglabeltext,
        }
        this.$store.dispatch('partnerlabel_add', { label: savelabel })
        .then(()=> {
          this.labels_get();
          this.conlabels_get(this.addinglabel);
          this.addinglabel = 0;
          this.addinglabeltext = '';
        });
      }
    },
    addlabel(id) {
      this.addinglabel = id;
      this.addinglabeltext = '';
      this.$nextTick(() => this.$refs['l'+id].focus())
    },
    removelabel(partner_id,partnerlabel_id) {
      this.$store.dispatch('partnerlabel_delete', { id: partnerlabel_id })
      .then(()=> {
        this.labels_get();
        this.conlabels_get(partner_id);
      });
    },
    partner_get(partner_id) {
      var partner_name = '';
      this.$store.dispatch('partner_fetch', { partner_id: partner_id })
      .then((resp) => {
        partner_name = resp.data.partner_name;
        for (var i=0; i<this.partners.length; i++) {
          if (this.partners[i].id == partner_id) {
            this.partners[i].partner_name = partner_name;
          }
        }
      });
    },
    conlabels_get(partner_id) {
      this.$store.dispatch('partnerlabels_fetch', { partner_id: partner_id })
      .then((resp) => {
         for (var i=0; i<this.partners.length; i++) {
           if (this.partners[i].id == partner_id) {
             this.partners[i].labels = resp.data;
           }
         }
      });
    },
    selectall(selected) {
      var setselectto = !selected;
      for (var i=0;i<this.partners.length; i++) {
        this.partners[i].selected = setselectto;
      }
      this.countselected();
    },
    countselected() {
      this.$nextTick(() => {
        var selectcount = 0;
        for (var i=0;i<this.partners.length; i++) {
          if (this.partners[i].selected) {
            selectcount++;
          }
        }
        this.selectcount = selectcount;
      })
    },
    partners_filter: _.debounce(function() {
      this.searchcalc = true
      setTimeout(function() {
        this.partners_filterget();
        this.searchcalc = false;
        this.searching = false;
      }.bind(this),500)
    },300),
    partners_sort(context) {
      this.orderby = context.sortBy;
      this.orderdesc = context.sortDesc;
      this.partners_filterget();
    },
    partners_filterget() {
      this.currentPage = 1;
      this.partners_get();
    },
    partners_get() {
      this.loading = true;
      var filter = '';
      if (this.search != '') {
        filter = {
          partner_name: {
            operator: 'LIKE',
            value: '%'+this.search+'%',
          },
        }
      }
      this.$store.dispatch('partners_fetch', {
        start: this.currentPage,
        limit: this.perPage,
        orderby: this.orderby,
        order: (this.orderdesc==false)?'ASC':'DESC',
        filter: filter,
        label_id: this.filterlabel,
        usergroup_id: this.filterusergroup,
      })
      .then((resp) => {
         this.partners = [];
         for (var i=0;i<resp.data.result.length;i++) {
           var labels = resp.data.result[i].labels;
           var result = {
             id: resp.data.result[i].id,
             selected: false,
             partner_name: resp.data.result[i].partner_name,
             labels: labels,
           }
           this.partners.push(result);
         }
         this.rows = resp.data.total;
         this.loading = false;
      });
    },
    labels_get() {
      this.$store.dispatch('labels_fetch')
      .then((resp) => {
        var dblabels = resp.data.result;
        var labels = [];
        for (var i=0;i<dblabels.length;i++) {
          var option = {
            value: dblabels[i].id,
            text: dblabels[i].label,
            color: dblabels[i].color,
          }
          labels.push(option);
        }
        labels.unshift({ value: 0, text: 'All labels',color: 'ffffff' });
        this.alllabels = labels;
      });
    },
  },
}
</script>
<style>
.gdq-faded {
  opacity: 0.5;
}
.headselect {
color: red;
  padding-top: 0px;
  padding-bottom: 0px;
  height: 30px;
  position: absolute;
  top: 20px;
}
</style>
